/**
 * @enum {string}
 */
export enum Themes {
  DEFAULT = 'base',
}
